import React, {useEffect, useState} from "react";
import {Button, DatePicker, Form, message} from "antd";
import {t} from "i18next";
import ApiService from "../../core/service/api-service";
import DeviceSelectBox from "../device/DeviceSelectBox";
import moment from "moment";

function WorklistItemSchedule({worklistItemId, onSaved})
{
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);
    const [hospitalId, setHospitalId] = useState(null);

    useEffect(() => {
        if (worklistItemId)
        {
            loadWorklistItem();
        }
    }, [worklistItemId]);

    const loadWorklistItem = async () =>
    {
        setInitialLoading(true);
        try {
            const response = await ApiService.WorklistItem.GetById(worklistItemId);
            if (response.success)
            {
                setHospitalId(response.data.study?.hospitalId);
                
                if (response.data.deviceId) {
                    form.setFieldsValue({
                        deviceId: response.data.deviceId,
                    });
                }
                
                if (response.data.scheduledStartTime) {
                    form.setFieldsValue({
                        scheduledStartTime: moment(response.data.scheduledStartTime),
                    });
                }
                
                if (response.data.scheduledEndTime) {
                    form.setFieldsValue({
                        scheduledEndTime: moment(response.data.scheduledEndTime),
                    });
                }
            }
        } finally {
            setInitialLoading(false);
        }
    }

    const onFinish = async (values) =>
    {
        setLoading(true);
        try {
            const response = await ApiService.WorklistItem.Schedule({
                id: worklistItemId,
                deviceId: values.deviceId,
                scheduledStartTime: values.scheduledStartTime?.format('YYYY-MM-DDTHH:mm:ss'),
                scheduledEndTime: values.scheduledEndTime?.format('YYYY-MM-DDTHH:mm:ss'),
            });

            if (response.success)
            {
                if (onSaved)
                {
                    onSaved();
                }
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            loading={initialLoading}
        >
            <Form.Item
                name="deviceId"
                label={t('Device')}
                rules={[
                    {required: true, message: t('DeviceRequired')},
                ]}
            >
                <DeviceSelectBox hospitalId={hospitalId}/>
            </Form.Item>

            <Form.Item
                name="scheduledStartTime"
                label={t('ScheduledStartTime')}
                rules={[
                    {required: true, message: t('ScheduledStartTimeRequired')},
                ]}
            >
                <DatePicker
                    showTime
                    format="DD.MM.YYYY HH:mm"
                    style={{width: '100%'}}
                />
            </Form.Item>

            <Form.Item
                name="scheduledEndTime"
                label={t('ScheduledEndTime')}
                rules={[
                    {required: true, message: t('ScheduledEndTimeRequired')},
                ]}
            >
                <DatePicker
                    showTime
                    format="DD.MM.YYYY HH:mm"
                    style={{width: '100%'}}
                />
            </Form.Item>

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{marginRight: 8}}
                >
                    {t('Schedule')}
                </Button>
                <Button
                    onClick={() => onSaved && onSaved()}
                >
                    {t('Cancel')}
                </Button>
            </Form.Item>
        </Form>
    )
}

export default WorklistItemSchedule;
